import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import cellEditFactory from "react-bootstrap-table2-editor";
import showNotification from "../../../helpers/show_notification";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../../helpers/units";
import printDiv from "../../../helpers/print_data";
import Breadcrumb_2Items from "../../Common/Breadcrumb_2Items";
import { AvField, AvForm } from "availity-reactstrap-validation";
import UpdateQuantityModal from "../../UpdateQuantityModal";

const AllItemDirectTransfers = (props) => {
  const store_id = localStorage.getItem("store_id");
  const [editModal, setEditModal] = useState();
  const role = localStorage.getItem("role");
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);
  const admin =
    role === "admin" ||
    role === "Owner" ||
    role === "Operations Manager" ||
    role === "Client Admin";

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
    if (admin) {
      loadAllStores();
    } else {
      loadAllOrders();
    }
  }, []);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [allStores, setAllStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("All");

  const loadAllOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const days_diff = moment(dateTo).diff(dateFrom, "days");
      let payload = {
        date_from: dateFrom || formatDate(new Date()),
        date_to: dateTo || formatDate(new Date()),
        store_id: admin ? selectedStore : store_id,
      };
      if (days_diff > 31) {
        setFilteredOrders([]);
        setAllOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (days_diff < 0) {
        setFilteredOrders([]);
        setAllOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      let url =
        process.env.REACT_APP_BASEURL +
        "storesitemstransfer/storewise_direct_transfer_items";
      const response1 = await postSubmitForm(url, payload);
      if (requestId !== ordersRequestId.current) return false;
      if (response1 && response1.status === 1) {
        const allData = (response1.data || []).map((row, index) => ({
          ...row,
          row_key: row._id || `row_${index}`,
          transferred_from_name:
            row.order_transferred_from && row.order_transferred_from.name
              ? row.order_transferred_from.name
              : "",
          transferred_to_name:
            row.order_transferred_to && row.order_transferred_to.name
              ? row.order_transferred_to.name
              : "",
        }));
        if (allData.length <= 0) {
          showNotification("No Orders data found", "error");
        }
        setAllOrders(allData);
        setFilteredOrders(allData);
      } else {
        showNotification((response1 && response1.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      showNotification(error, "Error");
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      let res = response.data.filter((obj) => obj.type !== "EQUIPMENT STORE");
      setAllStores(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  function afterFilter(newResult) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const [selectedOrder, setSelectedOrder] = useState();
  const isOrderedFromQualToOrderTransferredTo =
    selectedOrder?.order_transferred_to?._id === store_id;
  const [itemsModal, setItemsModal] = useState();

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Order Id"),
      dataField: "order_id",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Transferred From"),
      dataField: "transferred_from_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.transferred_from_name)
                .map((row) => [
                  row.transferred_from_name,
                  {
                    value: row.transferred_from_name,
                    label: row.transferred_from_name,
                  },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Transferred To"),
      dataField: "transferred_to_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.transferred_to_name)
                .map((row) => [
                  row.transferred_to_name,
                  {
                    value: row.transferred_to_name,
                    label: row.transferred_to_name,
                  },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (cell, row) =>
        moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.status)
                .map((row) => [
                  row.status,
                  { value: row.status, label: row.status },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      dataField: "action_col",
      isDummyField: true,
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <span className="text-info ml-2">
            <i
              className="mdi mdi-text-box-search font-size-15"
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setItemsModal(true);
                handleSetItemsForReceive(row.transferred_items);
                setSelectedOrder(row);
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const [itemsToReceive, setItemsToReceive] = useState([]);
  const [receiveModal, setReceiveModal] = useState();
  const [selectedItem, setSelectedItem] = useState();

  const handleSetItemsForReceive = async (items) => {
    if (items && items.length > 0) {
      let new_arr = items.map((item) => {
        let obj = {
          item_id: item.item_id,
          name: item.name,
          batch: item.batch,
          cost_price: item.cost_price,
          expiry_date: item.expiry_date,
          supplier_details: item.supplier_details,
          is_free: item.is_free,
          category: item.category,
          sub_category: item.sub_category,
          remarks: "",
          delivered_quantity: item.quantity?.map(({ unit, value }) => ({
            unit,
            value,
          })),
          quantity: item.quantity?.map(({ unit, value }) => ({
            unit,
            value,
          })),
          unit_levels: item.unit_levels,
        };
        return obj;
      });
      setItemsToReceive(new_arr);
    } else {
      setItemsToReceive([]);
    }
  };

  function compareQuantities(item) {
    const quantities = item.quantity;
    const quantitiesToCompare = item.delivered_quantity;
    const unitLevels = item.unit_levels;
    const convertedQuantities = convertToLowestUnit(unitLevels, quantities);
    const convertedQuantitiesToCompare = convertToLowestUnit(
      unitLevels,
      quantitiesToCompare,
    );

    let isPartial = false;
    if (convertedQuantities < convertedQuantitiesToCompare) {
      isPartial = true;
    }
    return isPartial;
  }

  const [isDisabled, setIsDisabled] = useState(false);
  const handleReceiveItems = async () => {
    try {
      setIsDisabled(true);
      let payload = {
        order_id: selectedOrder.order_id,
        item_order_id: selectedOrder.item_order_id,
        received_items: itemsToReceive,
        remarks: "",
      };
      let isNoRemarkUpdated = false;
      for (let item of itemsToReceive) {
        isNoRemarkUpdated = compareQuantities(item);

        if (isNoRemarkUpdated && item.remarks === "") {
          showNotification(
            "Enter remarks for all variances in received items.",
            "Warning",
          );
          setIsDisabled(false);
          return;
        }
      }
      let url =
        process.env.REACT_APP_BASEURL +
        "storesitemstransfer/receive_direct_transfer";
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        setReceiveModal(!receiveModal);
        setItemsModal(false);
        loadAllOrders();
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDisabled(false);
    }
  };

  function ReceiveFormatter(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">{formatUnitsForReport(row.quantity)}</span>

          {selectedOrder && selectedOrder.status !== "Completed" && (
            <Button
              className="btn btn-success  btn-sm"
              onClick={() => {
                const updatedItem = {
                  ...row,
                  quantity: row.quantity.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setEditModal(true);
              }}
            >
              <i className="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }

  const columns_to_receive = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Transferred Qty."),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity, row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("To Receive"),
      editable: false,
      formatter: ReceiveFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: () => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      editable: true,
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer", background: "#ffffaa" },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const columns_delivered_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },
    {
      dataField: "quantity",
      text: props.t("Delivered"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity, row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Received"),
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity, row.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const handleDownload = async () => {
    const fileName = "all_direct_transfers";
    const exportType = "xls";
    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;
    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          order_id: v.order_id,
          transferred_From: v.transferred_from_name,
          transferred_To: v.transferred_to_name,
          date: moment(v.createdAt).format("DD/MM/YYYY HH:mm"),
          status: v.status,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleSubmit = (quantity) => {
    let totalEntered = convertToLowestUnit(selectedItem.unit_levels, quantity);
    let totalDelivered = convertToLowestUnit(
      selectedItem.unit_levels,
      selectedItem.delivered_quantity,
    );
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem.unit_levels,
    );
    if (totalEntered > totalDelivered) {
      showNotification("Can not receive more than delivered", "Warning");
      return;
    }
    const updatedItems = itemsToReceive.map((item) => {
      if (item.item_id === selectedItem.item_id) {
        return {
          ...item,
          quantity: convertedQuantity?.map(({ unit, value }) => ({
            unit,
            value: parseFloat(value),
          })),
        };
      }
      return item;
    });

    setItemsToReceive(updatedItems);
    setEditModal(false);
    setSelectedItem();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Transfers")}
            alternateTitle={props.t("All Item Direct Transfers")}
            breadcrumbItem1={props.t("All Item Direct Transfers")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={() => {
                      loadAllOrders();
                    }}
                  >
                    <Row>
                      {admin && (
                        <Col lg={3} md={3}>
                          <AvField
                            name="store"
                            label={props.t("Store")}
                            type="select"
                            value={selectedStore}
                            onChange={(e) => {
                              setSelectedStore(e.target.value);
                            }}
                          >
                            <option value="All">{props.t("Select")}</option>
                            {allStores &&
                              allStores.map((store) => {
                                return (
                                  <option key={store._id} value={store._id}>
                                    {store.name}
                                  </option>
                                );
                              })}
                          </AvField>
                        </Col>
                      )}
                      <Col lg={3} md={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3} md={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3} md={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                        >
                          {isLoadingOrders ? (
                            <Spinner size="sm" className="mr-1" />
                          ) : (
                            <i className="mdi mdi-checkbox-marked-circle"></i>
                          )}{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="row_key"
                      data={(allOrders && allOrders) || []}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              {" "}
                              <CardTitle>All Item Direct Transfers </CardTitle>
                            </Col>
                            <Col lg={4} className="text-right"></Col>
                          </Row>
                          {isLoadingOrders ? (
                            <div className="text-center py-5">
                              <Spinner color="primary" />
                            </div>
                          ) : (
                            <BootstrapTable
                              striped
                              filter={filterFactory({ afterFilter })}
                              hover
                              condensed
                              pagination={paginationFactory(pagination_options)}
                              {...toolkitProps.baseProps}
                            />
                          )}
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="xl"
                    isOpen={itemsModal}
                    toggle={() => setItemsModal(!itemsModal)}
                  >
                    <ModalHeader toggle={() => setItemsModal(!itemsModal)}>
                      Order: {selectedOrder && selectedOrder.order_id}
                    </ModalHeader>
                    <ModalBody>
                      {selectedOrder && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      {itemsToReceive &&
                                      itemsToReceive.length > 0 &&
                                      isOrderedFromQualToOrderTransferredTo &&
                                      selectedOrder?.status === "Dispatched" ? (
                                        <>
                                          <Col lg={12}>
                                            <Label>
                                              {props.t("Transferred Items")}
                                            </Label>
                                            <ToolkitProvider
                                              keyField="item_id"
                                              data={itemsToReceive}
                                              columns={columns_to_receive}
                                            >
                                              {(toolkitProps) => (
                                                <div>
                                                  <BootstrapTable
                                                    {...toolkitProps.baseProps}
                                                    bootstrap4
                                                    keyField="item_id"
                                                    key="item_id"
                                                    cellEdit={cellEditFactory({
                                                      mode: "click",
                                                      blurToSave: true,
                                                    })}
                                                    noDataIndication="No data to display."
                                                    striped
                                                    hover
                                                    condensed
                                                  />
                                                </div>
                                              )}
                                            </ToolkitProvider>
                                          </Col>
                                          <Col
                                            lg={12}
                                            md={12}
                                            className="text-center"
                                          >
                                            <Label>&nbsp;</Label>
                                            <br />
                                            <Button
                                              type="button"
                                              color="primary"
                                              disabled={isDisabled}
                                              style={{ width: "110px" }}
                                              className="btn btn-default waves-effect waves-light "
                                              onClick={handleReceiveItems}
                                            >
                                              {isDisabled ? (
                                                <Spinner size="sm" />
                                              ) : (
                                                props.t("Receive")
                                              )}
                                            </Button>
                                          </Col>

                                          <UpdateQuantityModal
                                            isOpen={editModal}
                                            toggle={() => setEditModal(false)}
                                            onSubmit={handleSubmit}
                                            item={selectedItem}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <Col lg={12}>
                                            <Label>
                                              {props.t("Transferred Items")}
                                            </Label>
                                            <ToolkitProvider
                                              keyField="item_id"
                                              data={
                                                selectedOrder?.transferred_items
                                              }
                                              columns={columns_delivered_items}
                                            >
                                              {(toolkitProps) => (
                                                <div>
                                                  <BootstrapTable
                                                    {...toolkitProps.baseProps}
                                                    bootstrap4
                                                    keyField="item_id"
                                                    key="item_id"
                                                    noDataIndication="No data to display."
                                                    striped
                                                    hover
                                                    condensed
                                                  />
                                                </div>
                                              )}
                                            </ToolkitProvider>
                                          </Col>
                                        </>
                                      )}
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AllItemDirectTransfers)),
);
